import "./scss/index.scss";
import * as React from "react";
import * as ReactDOM from "react-dom";
import ReactSVG from "react-svg";
import { Button } from "..";
import closeImg from "../../images/modal-close.svg";
var modalRoot = document.getElementById("modal-root");

var Modal = function Modal(_ref) {
  var cancelBtnText = _ref.cancelBtnText,
      children = _ref.children,
      hide = _ref.hide,
      loading = _ref.loading,
      _ref$formId = _ref.formId,
      formId = _ref$formId === void 0 ? "modal-submit" : _ref$formId,
      submitBtnText = _ref.submitBtnText,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? modalRoot : _ref$target,
      show = _ref.show,
      title = _ref.title;
  return target && show ? ReactDOM.createPortal(React.createElement("div", {
    className: "overlay overlay--modal"
  }, React.createElement("div", {
    className: "overlay__modal"
  }, React.createElement("div", {
    className: "modal"
  }, React.createElement("div", {
    className: "modal__title"
  }, React.createElement("p", null, title), React.createElement(ReactSVG, {
    path: closeImg,
    className: "modal__close",
    onClick: hide
  })), React.createElement("div", {
    className: "modal__content"
  }, children), React.createElement("div", {
    className: "modal__footer"
  }, cancelBtnText && React.createElement("button", {
    className: "modal__cancelBtn",
    onClick: hide
  }, cancelBtnText), submitBtnText && React.createElement(Button, {
    type: "submit",
    form: formId,
    disabled: loading,
    className: "modal__button"
  }, loading ? "Loading" : submitBtnText))))), target) : null;
};

export default Modal;